import { render, staticRenderFns } from "./novel_list.vue?vue&type=template&id=6ec8e3b8&scoped=true"
import script from "./novel_list.vue?vue&type=script&lang=js"
export * from "./novel_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec8e3b8",
  null
  
)

export default component.exports